import axios from 'axios'
import qs from 'qs'
import { Toast, Indicator } from 'mint-ui';
import { removeStore } from '../config/utils';

//header参数
// axios 配置


var testUrl = "https://xy.cozzia.com.cn/chair/api/";
axios.defaults.timeout = 8000;
// axios.defaults.timeout = window.location.hostname == "xy.cozzia.com.cn" ? "800000000" : "8000";
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.baseURL = window.location.hostname == "xy.cozzia.com.cn" ? testUrl : process.env.API_ROOT;
axios.defaults.baseURL = process.env.API_ROOT;

//POST传参序列化
axios.interceptors.request.use((config) => {
    console.log("接口域名：" + axios.defaults.baseURL);
    Indicator.open({
        text: '正在加载...',
    });
    // if (config.method === 'post') {
    //     config.data = qs.stringify(config.data);
    // }
    return config;
}, (error) => {
    Toast("错误的传参");
    return Promise.reject(error);
});

//返回状态判断
axios.interceptors.response.use((res) => {
    Indicator.close();
    var resCode = res.data.statusCode;
    var msg_text = res.data.message;
    if (resCode && resCode !== 1 && resCode !== 304 && resCode !== 1001 && resCode !== 1002 && resCode !== 1003 && resCode !== 1004 && resCode !== 1008 && msg_text != "") { //不提示accesstoken失效
        if (res.data.message && res.data.message.trim() != "") {
            Toast({
                message: res.data.message,
                position: 'center',
                duration: 2000
            });
        }


    }
    if (res.data.statusCode === 304) {
        //accesstoken失效，清除login信息
        removeStore('loginInfo');
    }
    return res;
    // return Promise.reject(res);
}, (error) => {
    Indicator.close();
    Toast("网络异常");
    return Promise.reject(error);
});

//get请求
export function get(url, params = {}, showLoading = true) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
            showLoading: showLoading
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })


    })
}

//post请求
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            });
    })
}

//其他域名请求
export function postOther(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            });
    })
}

export default {
    wxAuth() {
        return get("user/oauth");
    },
    //咕啦彩票接口
    getLotteryInfo(params) {
        return get("/bannerGoodluck", params);
    },
    //************************** 公众号相关接口 *******************************
    //用户登录
    login(params) {
        return post('/user/register', params);
    },
    //高铁登录
    railwayLogin(params) {
        return post('/railway/user/register', params);
    },
    //获取验证码
    getMobileCode(params) {
        return get('/smsCode', params);
    },
    //获取用户信息
    getUserDetail(params) {
        return get('user/detail', params);
    },
    //修改用户信息
    updateUserDetail(params) {
        return post('user/update', params);
    },
    //用户消费记录
    getBillInfo(params) {
        return get("/user/orders", params);
    },
    //用户优惠券列表
    getCouponList(params) {
        return get("/user/coupons", params);
    },
    //意见反馈
    commitFeedback(params) {
        return post("/user/feedback", JSON.stringify(params))
    },
    // 可领取优惠券列表
    getCoupondraw(params) {
        return get("/coupon/list", params);
    },
    //获取优惠劵列表20180524
    // 
    getCouponallList(params) {
        return get("/coupon/findList", params);
    },
    //领取优惠券
    receiveCoupon(params) {
        return post("/coupon/receive", params);
    },
    //领取全部优惠券
    repairCouponList(params) {
        return post("/coupon/repairCouponList", params);
    },

    //兑换优惠券
    exchangeCoupon(params) {
        return post("/coupon/convert", params);
    },
    //**************************** 以下是扫码 接口 ********************************//
    getAibenList(params) {
        return post("/coupon/getExperiencePack", params);
    },
    getAibenCoupon(params) {
        return post("/coupon/receiveExperienceCoupon", params);
    },
    getAibenCouponList(params) {
        return post("/coupon/getExperienceCouponList", params);
    },
    //获取套餐列表
    getPackageList(params) {
        return get('/user/packageList', params);
    },
    // 分享爱奔优惠劵
    shareAiben(params) {
        return get('/coupon/scanExperienceCoupon', params);
    },
    // 领取爱奔优惠劵
    receiveAibencoupon(params) {
        return post('/coupon/receiveExperienceCoupon', params);
    },
    //猫眼优惠券兑换直接启动设备接口
    catBootDevice(params) {
        return post('/coupon/convertChannel', JSON.stringify(params));
    },
    // 20180621新增兑换码接口  /coupon/convertChannelCoupon
    catBootDeviceCoupon(params) {
        return post('/coupon/convertChannelCoupon', JSON.stringify(params));
    },
    //去支付
    pay(params) {
        return post("/order/payment", JSON.stringify(params));
    },
    //云闪付
    ysf(params) {
        return post("/order/ysf", params);
    },
    // 翼支付
    Yipay(params) {
        return post("/order/bestpay", JSON.stringify(params));
    },
    // 支付宝支付
    ourAlipay(tradeNo) {
        return post("/order/alipay", tradeNo);
    },
    //代币支付
    balancePayFinish(tradeNo) {
        return post("/balancePayFinish", tradeNo);
    },
    // /order/bestpay
    getWxConfig(params) {
        return get('/wxSign', params);
    },
    getOrderInfo(params) {
        return get('/order/info', params);
    },
    // 3.26.领取注册礼包
    receiveRegisterCoupon(params) {
        return post("/coupon/receiveRegisterCoupon", params);
    },
    findRewardInfo(params) {
        return get("/coupon/findRewardInfo", params);
    },
    getImgArr(params) {
        return get("/advertisingPosition/getAdvs", params);
    },
    getOrderCouponList(params) {
        return get("/coupon/getOrderCouponList", params);
    },
    //支付方式列表
    getCustomerPayTypeList(params) {
        return get("/user/getCustomerPayTypeList", params)
    },
    bingCard(params) {
        return post("/order/bingCard", params)
    },
    queryTradeResult(params) {
        return post("/order/queryTradeResult", params)
    },
    getBindCardInfo(params) {
        return post("/order/getBindCardInfo", params)
    },
    isActivitiesOpen(params) {
        return get("/coupon/isActivitiesOpen", params)
    },
    //赠送余额（代币）
    addRechargeBalancePhone(params) {
        return post("/member/recharge/balance/addRechargeBalancePhone", params)
    },
    //获取代币
    getBalanceDetailInfoByPhoneNum(params) {
        return post("/member/recharge/balance/getBalanceDetailInfoByPhoneNum", params)
    },
    //获取套餐
    getRechargeRuleList(params) {
        return get("/member/recharge/rule/getRechargeRuleListApi/" + params.dno)
    },
    //购买套餐
    payRechargeBalance(params) {
        return post("/member/recharge/pay/payRechargeBalance", params)
    },
    //消费明细
    getRechargeBillListByPhoneNum(params) {
        return post("/member/recharge/bill/getRechargeBillListByPhoneNum", params)
    },
    //订单支付
    comprehensivePayment(params) {
        return post("/railway/order/payment", params)
    },
    /********************************************************/
    //我的订单
    myOrder(params) {
        return post("/railway/order/list", params)
    },
    //倒计时
    getCountDown(params) {
        return get("/railway/getCountDown", params)
    },
    //个人中心
    getUderInfo(params) {
        return get("/user/getUderInfo", params)
    },
    //优惠劵
    couponsList(params) {
        return get("/user/couponsList", params)
    },
    //领取优惠劵
    receiveCoupong(params) {
        return post("/coupon/receiveCoupon", params)
    },
    //渠道商兑换券直接启动设备
    convertChannelCoupon(params) {
        return post("/coupon/convertChannelCoupon", params)
    },
    //无人货柜支付接口
    vendingPayment(params) {
        return post("/vending/pay/order/payment", params)
    },
    //第二单限时优惠
    checkedActivitySecondOrder(params) {
        if (process.env.API_ROOT == 'https://xy.cozzia.com.cn/chair/api/') {
            return get('https://xy.cozzia.com.cn/onlineOperation/api/activityCoupon/checkedActivitySecondOrderByDevice', params)
        } else {
            return get('/activityCoupon/checkedActivitySecondOrderByDevice', params)
        }

    },
    //获取动态参数接口
    getSmsCCC(params) {
        return get('/getSmsCCC', params)
    }
}


// WEBPACK FOOTER //
// ./src/http/api.js